<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        
        <b-card>
          <div slot="header" v-if="display_entity">
            Ajout d'un <strong>utilisateur</strong>  
          </div>
          <div slot="header" v-if="!display_entity">
            Modification d'un modèle <strong>de paiement de masse</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="nom">Nom *</label>
              <b-form-input id="nom" type="text" v-model="model.nom" placeholder="Nom " ></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="prenom">Prénom(s) </label>
              <b-form-input type="text" v-model="model.prenom" placeholder="prenom" id="prenom"></b-form-input>
            </b-col>              
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="identifiant">Identifiant *</label>
              <b-form-input id="identifiant" type="text" v-model="model.identifiant" placeholder="identifiant" ></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="adresse">Adresse *</label>
              <b-form-input type="text" v-model="model.adresse" placeholder="adresse" id="adresse"></b-form-input>
            </b-col>              
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="montant_transfere">Montant transféré *</label>
              <b-form-input id="montant_transfere" type="text" v-model="model.montant_transfere" placeholder="Montant transféré" ></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="telephone">Téléphone </label>
              <b-form-input type="text" v-model="model.telephone" placeholder="Téléphone" id="telephone"></b-form-input>
            </b-col>              
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="periodicite_jour">Périodicité jour *</label>
              <b-form-input id="periodicite_jour" type="number" v-model="model.periodicite_jour" placeholder="Périodicité en jour" ></b-form-input>
            </b-col>            
            <b-col md="6">
              <label for="model">Model *</label>
              <b-form-input id="model" type="text" v-model="model.model" placeholder="Model" ></b-form-input>
            </b-col> 
            <b-col md="6">
              <label for="grilletarifaires_libelle">Grille Tarifaire</label>
              <b-form-select id="grilletarifaires_libelle" :plain="true" :options="options_grille" v-model="model.grilletarifaires_libelle">
              </b-form-select>
              <!--<b-form-input type="text" v-model="typeoperation.sens" placeholder="Sens : Retrait ..."></b-form-input>-->
            </b-col>            
          </b-row>
  
          
          <div slot="footer">
            <span v-if="can('modelpaiement-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      userConnected:{},
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      display_entity :false,
      display_agency :false,
      options : [],
      t : [],
      options_agency : [],
      options_roles : [],
      model:{
        id:'',
        model: '',
        nom: '',
        prenom: '',
        identifiant: '',
        adresse:'',
        montant_transfere: '',
        telephone: '',
        periodicite_jour: '',
        grilletarifaires_libelle:'',
        _method:'PUT'
      },
      entities:[],
      agencies:[],
      entite_name :'',
      grise_element:false,
      view_passord : false,
      class_password : {
        icon : "fa fa-eye",
        type : 'password',
        text:''
      },
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 20
      },
      value1: [],
      value2: [],

      options_grille:[],
      options4: [],
      options5: [],
        value9: [],
        list: [],
        loading: false,
        states: []
    }
  },
  methods:{
    
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    see(){
        if (this.view_passord==false){
            this.class_password.icon ="fa fa-eye"
            this.class_password.type ="password"
            this.view_passord = true
        }else{
            this.class_password.icon ="fa fa-eye-slash"
            this.class_password.type ="text"
            this.view_passord = false
        }
    },
    async get_all_grilletarifaires(){
      await this.$store.dispatch('grilletarifaire/get_all_grilletarifaires',this.serverParams).then(()=>{
        return this.grille =  store.getters['grilletarifaire/rows'];
      })
      this.grille.forEach((element)=>{
          this.options_grille.push({
            value:element.libelle,
            text:element.libelle.toUpperCase()
          })
      })
      this.options_grille.push({
        value:null,
        text:'Par défaut'
      })
    },
    confirmation(){
        if(this.user.password != this.user.password_confirmation){
          this.class_password.text = "Le mot de passe et le mot de passe de confirmation sont incorrects"
        }else{
          this.class_password.text = "Correct !"
        }
    },
    async post(){     
        this.model.id=this.$route.params.id_model
        this.response = await this.$store.dispatch('mandate/put_model',this.model)
        this.showAlert() 
        // if (this.response.success==true){
        //   this.reset()
        // }
    },
    async get_all_entities(query){
      
      if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
          this.userConnected = await store.getters['auth/get_user']
          if (this.userConnected.role.toUpperCase() == 'SUPER ADMIN'){
               this.display_entity = true
               this.display_agency = false
              let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10,
                nom_commercial: query,
              }
              await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
              })
              this.entities.forEach((element)=>{
                  this.options.push({
                    value:element.id,
                    text:element.nom_commercial.toUpperCase(),
                  })
              })
              this.t = this.options
          }else{
              
              this.display_entity =  false
              this.display_agency =true
              let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10
              }
              await this.$store.dispatch('agency/get_all_agenciesOwn',serverParams).then(()=>{
                return this.agencies = store.getters['agency/rows'];    
              })
              this.agencies.forEach((element)=>{
                  this.options_agency.push({
                    value:element.id,
                    text:element.nom_agence.toUpperCase(),
                  })
              })
              await this.$store.dispatch('entity/get_all_authentites',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
              })
              this.entities.forEach((element)=>{
                  this.options.push({
                    value:element.id,
                    text:element.nom_commercial.toUpperCase(),
                  })
              })
          }
          //this.entities =  store.getters['entity/rows'];
          
            
            if(this.options.length==1){
                this.user.entite_id = this.options[0].value
            }
          }else{         
          this.display_entity = false
          this.user.entite_id = this.$route.params.entite_id
          await this.$store.dispatch('entity/show_entites',this.user.entite_id).then((res)=>{
            return this.entite_name = res.nom_commercial
          })
          this.options.push({
            value:this.$route.params.entite_id,
            text:this.$route.params.entite_id
          })
      }

    },
    choose_code(){
      console.log("mon role",this.user.roles)
      if(this.user.roles.toUpperCase()==="CHEF AGENCE"){
        this.display_agency=true
        this.display_entity =false
      }else if(this.user.roles.toUpperCase()==="RESPONSABLE POSTE" || this.user.roles.toUpperCase()==="RESPONSABLE DISTRIBUTEUR"){
        this.display_agency=false
      }else{
        this.display_agency=true
        this.display_entity =false
      }
    },
    // async findRoles(role){
    //   await this.$store.dispatch('role/get_all_roles').then(()=>{
    //       store.getters['role/rows'].forEach(element => {
    //         this.options_roles.push({
    //           value:element.name,
    //           text:element.name.toUpperCase()
    //         })
    //       });
    //     })
    //   this.options_roles.fin
    // },get_roles_by_entite
    async get_all_roles(){
     if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
        this.param_role = null
     }else{this.param_role=this.$route.params.entite_id}
      await this.$store.dispatch('role/get_roles_by_entite',{entite_id:this.param_role}).then(()=>{
        store.getters['role/rows'].forEach(element => {
          this.options_roles.push({
            value:element.name,
            text:element.name.toUpperCase()
          })
        });
      }) 
      if(this.options_roles.length==1){
        this.user.roles = this.options_roles[0].value
          console.log('taille :',this.options_roles[0]) 
          this.grise_element = true
      }
      // }else{
      //    await this.$store.dispatch('role/get_roles_by_entite').then(()=>{
      //     store.getters['role/rows'].forEach(element => {
      //       console.log('role element ',element)
      //       this.options_roles.push({
      //         value:element.name,
      //         text:element.name.toUpperCase()
      //       })
      //     });
      //   }) 
     // }
    },
    async get_user(){
        this.userConnected = await store.getters['auth/get_user']
        return this.userConnected 
    },
    async displayModel(){
        let response = await this.$store.dispatch('mandate/get_model_by_id',this.$route.params.id_model)
        this.model.adresse= response.adresse,
        this.model.identifiant= response.identifiant,
        this.model.model= response.model,
        this.model.montant_transfere= response.montant_transfere,
        this.model.nom= response.nom,
        this.model.periodicite_jour=response.periodicite_jour
        this.model.prenom=response.prenom
        this.model.telephone=response.telephone
        this.model.grilletarifaires_libelle=response.grilletarifaires_libelle
    },
    reset(){
      this.user.name= '',
      this.user.roles= '',
      this.user.email= '',
      this.user.password= '' 
      this.user.password_confirmation= '' 
    },
    goBack() {
      this.$router.go(-1)
    },
    remoteEntities(query) {
        this.get_all_entities(query)
        console.log("ma requete 1",this.t)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.t.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          console.log("ma requete 2 ",this.t)
        } else {
          this.options4 = [];
        }
        this.options = [] 
        // console.log("ma requete 3 ",this.options)
    },
    remoteAgencies(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options5 = this.options_agency.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options5 = [];
        }
    }
  },
  mounted(){
    // this.list = this.states.map(item => {
    //     return { value: item, label: item };
    //   });
    // console.log("mes options ",url_redirect)
    // this.get_user()
    // this.get_all_entities('')
    this.displayModel()
    this.get_all_grilletarifaires()
  }
}
</script>
